(function () {
  var MOBILE_BP = 992;
  var toggles = document.querySelectorAll('[data-dc-dropdown="parent"]');
  if (!toggles.length) return;

  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  function closeSiblings(currentLi) {
    var parent = currentLi.parentElement;
    if (!parent) return;
    var siblings = parent.querySelectorAll(':scope > .dropdown.is-open');
    siblings.forEach(function (sib) {
      if (sib === currentLi) return;
      sib.classList.remove('is-open');
      sib.querySelectorAll('.dropdown.is-open').forEach(function (nested) {
        nested.classList.remove('is-open');
        var nm = nested.querySelector(':scope > .dropdown-menu');
        if (nm) nm.classList.remove('show');
        var nt = nested.querySelector(':scope > [data-dc-dropdown]');
        if (nt) nt.setAttribute('aria-expanded', 'false');
      });
      var sm = sib.querySelector(':scope > .dropdown-menu');
      if (sm) sm.classList.remove('show');
      var st = sib.querySelector(':scope > [data-dc-dropdown]');
      if (st) st.setAttribute('aria-expanded', 'false');
    });
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var li = toggle.closest('.dropdown');
      var menu = li ? li.querySelector(':scope > .dropdown-menu') : null;
      if (!li || !menu) return;

      var isOpen = li.classList.contains('is-open');

      if (isOpen) {
        return;
      }

      e.preventDefault();
      closeSiblings(li);
      li.classList.add('is-open');
      menu.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');
    });
  });

  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    if (!e.target.closest('.dropdown')) {
      document.querySelectorAll('.dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        var m = d.querySelector(':scope > .dropdown-menu');
        if (m) m.classList.remove('show');
        var t = d.querySelector(':scope > [data-dc-dropdown]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
